import React, {createRef, useState, useContext, Fragment} from 'react';
import __ from "lodash";
import moment from "moment";
import {useAuth0} from "@auth0/auth0-react";
import { v4 as uuidv4 } from 'uuid';
import MaterialTable from "@material-table/core";
import { defaultComponents, MaterialTableBody, MaterialTableBodyRow } from '../../../../controls/Material-Table-Components';

import SystemContext from "../../../../SystemContext";

import {ColumnWidth, ValidatorColumn} from "../../../../blocks/ColumnHelper";
import ServicesEditorValidator from "../../validators/ServicesEditorValidator";
import { useTheme } from '@material-ui/core';


const CateringEditor = (_props) => {
  const SystemData = useContext(SystemContext);
  const theme = useTheme();
  const tableRef = createRef({state: {lastEditingRow: false}});
  const {isAuthenticated} = useAuth0();
  const eventBus = SystemData.eventBus;

  const props = {
    ..._props
  }
  const {classes, flightRecord, skeletonMeals, skeletonDryStore, dryStore, blockTime, departureTime, crewNumber, additionalSectors} = props;

  const [state] = useState({
    canEdit: props.canEdit,
    activeRow: null
  });

  const calculateQuantity = (data, blockTime, departureTime, crewNumber = 0) => {
    if (departureTime === "00:00")
      departureTime = "00:01";
    const blocks = __.has(data, "records") ? data.records : [];
    const recordType = __.has(data, "type") ? data.type : "";
    if (blocks && Array.isArray(blocks) && blocks.length > 0) {
      if (recordType === "TIME") {
        for (let i = 0; i < blocks.length; i++) {
          const block = blocks[i];
          if (moment(departureTime, "HH:mm").isBetween(moment(block.fromLocalTime, "HH:mm"), moment(block.toLocalTime, "HH:mm"), undefined, "[]")) {
            return (moment(blockTime, "HH:mm").isAfter(moment(block.minDutyTime, "HH:mm")) ? 1 : 0) * crewNumber;
          }
        }
        return 0;
      } else if (recordType === "DURATION") {
        for (let i = 0; i < blocks.length; i++) {
          const block = blocks[i];
          if (moment(blockTime, "HH:mm").isAfter(moment(block.dutyHours, "HH:mm")))
            continue;
          return block.quantity * (block.perPerson ? crewNumber : 1);
        }
      }
    }

    return 0;
  }

  const calculatePerPersonQuantity = (quantityItem, item, crewNumber, tripSectorCount) => {
    const quantity = quantityItem ? item.data.quantity : 0;
    let personMultiplier = 1;
    let tripSectorCountMultiplier = 1;
    if(__.has(item.data, "perPerson") && item.data.perPerson) {
      personMultiplier = crewNumber;
      tripSectorCountMultiplier = tripSectorCount > 1 && __.has(item.data, "sectorCountFactor") ? tripSectorCount * item.data.sectorCountFactor : 1;
    }

    return Math.ceil(quantity * personMultiplier * tripSectorCountMultiplier);
  }

  const buildSectionData = (catering, dryStore, blockTime, departureTime, crewNumber, airport, tripSectorCount = 1) => {
    const cateringOrder = [];



    if (catering && catering.data) {
      catering.data.forEach(item => {
        if (__.has(item, "data")) {
          const quantityItem = __.has(item.data, "quantity");
          const quantity = (dryStore || !__.has(item.data, "records"))
            ?
              calculatePerPersonQuantity(quantityItem, item, crewNumber, tripSectorCount)
            :
              calculateQuantity(item.data, blockTime, departureTime, crewNumber);

          const cateringItem = {
            id: uuidv4(),
            cateringItemUuid: uuidv4(),
            cateringItemName: item.value,
            cateringItemCode: item.code,
            quantityRequired: quantity,
            quantityOrdered: 0,
          };

          if (!quantityItem)
            cateringOrder.push(cateringItem);
          else if (! __.has(item.data, ["airportExtra"]))
            cateringOrder.push(cateringItem);
          else if (!item.data.airportExtra)
            cateringOrder.push(cateringItem);
          else if (!__.has(item.data, ["airports"]) || !Array.isArray(item.data.airports))
            cateringOrder.push(cateringItem);
          else if(item.data.airports.includes(airport))
            cateringOrder.push(cateringItem);
        }
      });
    }

    return cateringOrder;
  }

  const buildSkeletonCatering = (skeletonMeals, skeletonDryStore, dryStore, blockTime, departureTime, crewNumber, airport, additionalSectors, tripSectorCount) => {
    if (flightRecord.flightCateringOrder && (
        (__.has(flightRecord.flightCateringOrder, "crewNumber") && flightRecord.flightCateringOrder.crewNumber === crewNumber) &&
        (__.has(flightRecord.flightCateringOrder, "additionalSectors") && __.isEqual(flightRecord.flightCateringOrder.additionalSectors, additionalSectors)) ||
        (__.has(flightRecord.flightCateringOrder, "status" && flightRecord.flightCateringOrder.status === 'SECTOR')))) {
      if (!flightRecord.flightCateringOrder["dryStores"] || __.isEmpty(flightRecord.flightCateringOrder["dryStores"])) {
        flightRecord.flightCateringOrder["dryStores"] = buildSectionData(skeletonDryStore, true, blockTime, departureTime, crewNumber, airport, tripSectorCount);
      }
      return flightRecord.flightCateringOrder[`${dryStore?"dryStores":"meals"}`];
    }

    const cateringMealOrder = buildSectionData(skeletonMeals, false, blockTime, departureTime, crewNumber, airport);
    const cateringDryStore = buildSectionData(skeletonDryStore, true, blockTime, departureTime, crewNumber, airport, tripSectorCount);
    // if (additionalSectors && Array.isArray(additionalSectors)) {
    //   additionalSectors.forEach(sector => {
    //     const sectorBlockTime =  moment(moment(sector.scheduledArrivalTimeUTC).diff(moment(sector.scheduledDepartureTimeUTC))).format("HH:mm");
    //     const departureTimeLocal = moment(sector.scheduledDepartureTimeUTC).tz(sector.departureAirportTimeZone).format("HH:mm");

    //     const sectorMealOrder =  buildSectionData(skeletonMeals, false, sectorBlockTime, departureTimeLocal, crewNumber, airport);
    //     const sectorDryStore = buildSectionData(skeletonDryStore, true, sectorBlockTime, departureTimeLocal, crewNumber, airport);

    //     cateringMealOrder.forEach(item => {
    //       const sectorItem = __.find(sectorMealOrder, {cateringItemName: item.cateringItemName});
    //       item["quantityRequired"] += sectorItem !== undefined ? sectorItem["quantityRequired"] : 0;
    //     })

    //     // Do not update dry store order for additional sectors
    //     // ====================================================
    //     // cateringDryStore.forEach(item => {
    //     //   const sectorItem = __.find(sectorDryStore, {cateringItemName: item.cateringItemName});
    //     //   item["quantityRequired"] += sectorItem !== undefined ? sectorItem["quantityRequired"] : 0;
    //     // })
    //   })
    // }

    const cateringOrder = dryStore ? cateringDryStore : cateringMealOrder;

    const flightCateringOrder = props.flightRecord?.flightCateringOrder || {};
    flightCateringOrder["meals"] = cateringMealOrder;
    flightCateringOrder["dryStores"] = cateringDryStore;
    flightCateringOrder[`crewNumber`] = crewNumber;
    flightCateringOrder[`replenishDryStore`] = dryStore;
    flightCateringOrder[`additionalSectors`] = additionalSectors;
    props.onChange({record: {...props.flightRecord, flightCateringOrder: flightCateringOrder}, oldRecord: props.flightRecord});

    return cateringOrder;
  }

  const flightCateringOrder = buildSkeletonCatering(skeletonMeals, skeletonDryStore, dryStore, blockTime, departureTime, crewNumber, flightRecord.originAirportCode, additionalSectors, flightRecord.sectorCount);
  const getColumns = (props) => {
    const baseColumn = {
      cellStyle: { padding: "8px 2px" },
      headerStyle: { padding: "8px 2px" },
      editable: state.canEdit?"always":"never",
      emptyValue: "",
      initialEditValue: "",
      sorting: false
    };
    const defaultEditProps = {
      style:{fontSize: "0.875rem"}
    };

    const validatorColumn = ValidatorColumn(ServicesEditorValidator, false);

    return [
      {...validatorColumn},
      {
        ...baseColumn,
        ...ColumnWidth(700,6,undefined,undefined,undefined,undefined,false),
        title: "Item",
        field: "cateringItemName",
        editable: "never",
      },
      {
        ...baseColumn,
        ...ColumnWidth(120,2,undefined,undefined,undefined,undefined,false),
        title: "Required",
        field: "quantityRequired",
      },
    ];
  };


  const bodyRef = createRef();

  return (isAuthenticated &&
        <div className={classes.TripLegEditor}>
          <MaterialTable
            tableRef={tableRef}
            data={flightCateringOrder}
            style={{
              backgroundColor: "#fdfdfd",
              boxShadow: "none",
              border: "2px solid #aaaaaa",
              borderRadius: 0,
            }}
            options={{
              actionsColumnIndex: -1,
              search: false,
              cellStyle: {
                padding: "8px 2px",
              },
              headerStyle: {
                backgroundColor: theme.palette.childTableHeader.backgroundColor,
                color: theme.palette.childTableHeader.textColor,
                padding: "2px",
              },
              toolbarButtonAlignment: "right",
              detailPanelType: "single",
              showTitle: false,
              toolbar: false,
              padding: 'dense',
              paging: false,
              filtering: false,
              draggable: false,
              onEditModeChanged: (editMode)=> {
                if (props.changeButtonState) {
                  const changes = {
                    save: {disabled: false, hidden: false},
                  }
                  if (editMode) {
                    changes['save'] = {disabled: true, hidden: false}
                  }
                  props.changeButtonState(changes);
                }
              },
            }}
            components={{
              ...defaultComponents,
              Body: (props) => (
                <MaterialTableBody
                  {...props}
                  ref={bodyRef}
                  rowHeight={46}
                  overscanRowCount={10}
                  addVirtualScrolling={true}
                  bodyHeight={300}
                  headerHeight={46}
                />
              ),
              Row: (props) => (
                <MaterialTableBodyRow
                  {...props}
                />
              ),
            }}
            title="Catering Order"
            columns={getColumns({...props, canEdit: state.canEdit})}
            actions={[
            ]}
            editable={{
              isEditable: () => {
                return state.canEdit;
              },
              isDeletable: () => {
                return state.canEdit;
              },
              onRowAdd:  undefined,
              onRowUpdate: state.canEdit
                  ? (newData, oldData) => new Promise((resolve, reject) => {
                      const cateringItemIdx = __.findIndex(flightCateringOrder, {cateringItemUuid: oldData.cateringItemUuid});
                      if (cateringItemIdx >= 0) {
                        flightCateringOrder[cateringItemIdx] = newData;
                        const catering = props.flightRecord?.flightCateringOrder || {};
                        catering[`${dryStore?"dryStores":"meals"}`] = flightCateringOrder;
                        props.onChange({record: {...props.flightRecord, flightCateringOrder: catering}, oldRecord: props.flightRecord, resolve, reject});
                      } else {
                        reject();
                      }
                    })
                  : undefined,
              onRowDelete: state.canEdit
                ? (oldData) => new Promise((resolve, reject) => {
                    const cateringItemIdx = __.findIndex(flightCateringOrder, {cateringItemUuid: oldData.cateringItemUuid});
                    if (cateringItemIdx >= 0) {
                      flightCateringOrder.splice(cateringItemIdx, 1);
                      const catering = props.flightRecord?.flightCateringOrder || {};
                      catering[`${dryStore?"dryStores":"meals"}`] = flightCateringOrder;
                      props.onChange({record: {...props.flightRecord, flightCateringOrder: catering}, oldRecord: props.flightRecord, resolve, reject});
                    } else {
                      reject();
                    }
                  })
                : undefined,
            }}
        />
      </div>
  );
}

export default CateringEditor;
